import { PaginationResponse } from '@repo/ui/data-table'

import { CseContact, CseContactInput } from '../../lib/types/models/cse/cse-contact'
import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const createCseContact = ({ id, ...data }: IdInput<CseContactInput>) => {
  return restApiClient
    .url(constructApiUrl(API.cse.createContact.url, { id }))
    .post<CseContact, CseContactInput>(data)
}

export const getAllCseContacts = (id: number) => {
  return restApiClient
    .url(constructApiUrl(API.cse.getAllContacts.url, { id }))
    .get<PaginationResponse<CseContact>>()
}

export const getCseContact = (id: number, contactId: number) => {
  return restApiClient
    .url(constructApiUrl(API.cse.getContact.url, { id, contactId }))
    .get<CseContact>()
}

export const updateCseContact = ({
  id,
  contactId,
  ...data
}: CseContactInput & { id: number; contactId: number }) => {
  return restApiClient
    .url(constructApiUrl(API.cse.updateContact.url, { id, contactId }))
    .patch<CseContact, CseContactInput>(data)
}

export const deleteCseContact = (id: number, contactId: number) => {
  return restApiClient.url(constructApiUrl(API.cse.deleteContact.url, { id, contactId })).delete()
}
